import { render, staticRenderFns } from "./ClientDragAndDropCSVFile.vue?vue&type=template&id=47a0357e&scoped=true&"
import script from "./ClientDragAndDropCSVFile.vue?vue&type=script&lang=js&"
export * from "./ClientDragAndDropCSVFile.vue?vue&type=script&lang=js&"
import style0 from "./ClientDragAndDropCSVFile.vue?vue&type=style&index=0&id=47a0357e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a0357e",
  null
  
)

export default component.exports